import { ExperienceInfo, StackItem } from '@consts';

export const getStackList = (experience: ExperienceInfo[]) => {
  const stack = [...experience].reduce((res: StackItem[], exp) => {
    exp.stack.forEach((stackItem) => {
      const names = res.map((one) => one.name);
      if (names.includes(stackItem.name)) {
        const currentStack = res.find((one) => one.name === stackItem.name);
        if (currentStack) currentStack.length += stackItem.length;
      } else {
        res.push({
          ...stackItem,
        });
      }
    });
    return res;
  }, []);

  const maxLength = Math.max(...stack.map((one) => one.length));
  stack.forEach((one) => {
    one.length /= maxLength;
  });

  return stack;
};
